import type {Locale} from 'antd/lib/locale';

import fa_IR from 'antd/lib/locale/fa_IR';

export const jalaliLocale: Locale = {
  ...fa_IR,
  DatePicker: {
    ...fa_IR.DatePicker,
    lang: {
      ...(fa_IR.DatePicker?.lang || {}),
      monthFormat: 'MMMM',
      monthBeforeYear: true,
      monthSelect: 'ماه را انتخاب کنید',
      yearSelect: 'سال را انتخاب کنید',
      locale: 'fa',
      today: 'امروز',
      now: 'اکنون',
      backToToday: 'بازگشت به امروز',
      ok: 'تایید',
      timeSelect: 'انتخاب زمان',
      dateSelect: 'انتخاب تاریخ',
      clear: 'پاک کردن'
    }
  }
} as Locale;

export const jalaliLocaleRangePicker: Locale = {
  ...fa_IR,
  DatePicker: {
    ...fa_IR.DatePicker,
    lang: {
      ...(fa_IR.DatePicker?.lang || {}),
      locale: 'fa',
      monthFormat: 'MMMM',
      monthBeforeYear: true,
      monthSelect: 'ماه را انتخاب کنید',
      yearSelect: 'سال را انتخاب کنید',
      today: 'امروز',
      now: 'اکنون',
      backToToday: 'بازگشت به امروز',
      ok: 'تایید',
      timeSelect: 'انتخاب زمان',
      dateSelect: 'انتخاب تاریخ',
      clear: 'پاک کردن',
      yearFormat: 'YYYY',
      decadeFormat: 'YYYY',
      rangeYearFormat: 'YYYY',
      rangeMonthFormat: 'MMMM',
      rangeWeekFormat: 'wo',
      rangeQuarterFormat: 'QQQ',
      rangeMonthBeforeYear: true
    }
  },
  Calendar: {
    ...fa_IR.Calendar,
    lang: {
      ...(fa_IR.Calendar?.lang || {}),
      locale: 'fa',
      monthFormat: 'MMMM',
      monthBeforeYear: true
    }
  }
} as Locale;
